var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3260.8695652173915,
    height: 1630.4347826086955,
    viewBox: "0 0 3260.8695652173915 1630.4347826086955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(13.043478260869565) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs7103"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG7104",
    featureKey: "rootContainer",
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    height: 1,
    width: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 230,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG7105",
    featureKey: "symbolFeature-0",
    transform: "matrix(1.3043478260869565,0,0,1.3043478260869565,-11.73913043478261,11.478260869565217)",
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("metadata", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "http://ns.adobe.com/SaveForWeb/1.0/"
  }, /*#__PURE__*/React.createElement("slices", null, /*#__PURE__*/React.createElement("slicesourcebounds", {
    height: 16384,
    width: 16389,
    x: -8165,
    y: -8160,
    bottomleftorigin: "true"
  })))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,15c-8.748,0-13-2.944-13-9c0-0.552-0.447-1-1-1H24c-0.552,0-1,0.448-1,1c0,6.056-4.252,9-13,9c-0.552,0-1,0.448-1,1v18   c0,10.37,21.544,24.257,22.461,24.843C31.625,58.947,31.813,59,32,59s0.375-0.053,0.539-0.157C33.456,58.257,55,44.37,55,34V16   C55,15.448,54.553,15,54,15z M25.707,37.293c0.391,0.391,0.391,1.023,0,1.414C25.512,38.902,25.256,39,25,39   s-0.512-0.098-0.707-0.293l-6-6c-0.391-0.391-0.391-1.023,0-1.414l6-6c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414   L20.414,32L25.707,37.293z M35.958,22.287l-6,20C29.828,42.721,29.431,43,29,43c-0.095,0-0.192-0.014-0.288-0.042   c-0.529-0.159-0.83-0.717-0.671-1.245l6-20c0.158-0.529,0.715-0.83,1.245-0.671C35.816,21.201,36.116,21.758,35.958,22.287z    M45.707,32.707l-6,6C39.512,38.902,39.256,39,39,39s-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414L43.586,32   l-5.293-5.293c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l6,6C46.098,31.684,46.098,32.316,45.707,32.707z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG7106",
    featureKey: "nameFeature-0",
    transform: "matrix(1.6789206089878714,0,0,1.6789206089878714,79.67093059354772,9.735644425232621)",
    fill: "#111111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.93 40 l-1.8555 -5.3125 l-11.484 0 l-1.8359 5.3125 l-7.5586 0 l10.566 -28.711 l9.1602 0 l10.566 28.711 l-7.5586 0 z M11.719 28.555 l7.2266 0 l-3.6133 -10.391 z M52.62140625 40 l-1.8555 -5.3125 l-11.484 0 l-1.8359 5.3125 l-7.5586 0 l10.566 -28.711 l9.1602 0 l10.566 28.711 l-7.5586 0 z M41.41040625 28.555 l7.2266 0 l-3.6133 -10.391 z M75.1448125 40.39063 c-8.4375 0 -14.473 -5.8789 -14.473 -14.668 c0 -8.9648 6.2305 -14.844 14.902 -14.844 c5.7617 0 10.41 2.5586 12.93 6.7969 l-6.5234 3.4766 c-1.2695 -2.6367 -3.5547 -3.9063 -6.4063 -3.9063 c-4.3164 0 -7.4805 2.9883 -7.4805 8.2813 c0 4.9609 2.8125 8.5156 7.7734 8.5156 c2.7539 0 5.8008 -1.1133 6.7188 -4.3555 l-6.6797 0 l0 -5.8789 l13.633 0 l0 16.191 l-5.7617 0 l0 -3.0859 c-1.7969 2.1289 -4.5508 3.4766 -8.6328 3.4766 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBack);
export default __webpack_public_path__ + "static/media/logo-no-back.97fae920f0df46c72373d9b8cb3d2878.svg";
export { ForwardRef as ReactComponent };